import React from "react";
import { useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Header from "./Header";
import Footer from "./Footer";
import ShaktiPopup from "@/components/ShaktiPopup";

/**
 * UserLayout - Main layout wrapper for all user-facing pages
 * Includes Header, Footer, and conditional margin for non-home pages
 */
const UserLayout = ({ children }) => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <Toaster />
      <main className={`flex-grow ${!isHomePage ? "mt-12 sm:mt-16" : ""}`}>
        {children}
      </main>
      <ShaktiPopup />
      <Footer />
    </div>
  );
};

export default UserLayout;
